import React from 'react';
import { css } from '@emotion/react';
import { IconCross } from 'icons/icon-cross';
import { Button } from 'components/Button';
import { QUERY_BOOKER_REQUEST_DATA } from 'queries/queries-booker';
import { useQuery } from 'urql';
import { format } from 'date-fns';
import { theme } from 'styles/theme';
import { ExportToCalendar } from 'screens/booker/components/ExportToCalendar';

export const RequestExportDrawer = ({ onClose, url }) => {
	const [requestDetail, executeRequestDetail] = useQuery({
		query: QUERY_BOOKER_REQUEST_DATA,
		variables: { url: url },
	});

	const { fetching, data, error } = requestDetail;

	return (
		<div
			css={css`
				position: fixed;
				top: 0;
				right: 0;
				background: #fff;
				height: 100%;
				box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
				width: 720px;
				display: flex;
				flex-direction: column;
				z-index: 9900;
			`}
		>
			<div
				css={css`
					display: flex;
					justify-content: space-between;
					padding: 16px 16px 16px 16px;
					border-bottom: 1px solid #f0f0ff;
					align-items: center;
				`}
			>
				<div>
					{!fetching && (
						<>
							<h3>Export do kalendáře - {data.requestDetail?.artist?.name}</h3>
							<div>
								{data.requestDetail.event_name},{' '}
								{format(new Date(data.requestDetail.event_date), 'dd. MM. YYY')},{' '}
								{data.requestDetail.event_address_city}
							</div>
							<div
								css={css`
									font-size: 13px;
									color: ${theme.color.text['300']};
								`}
							>
								{data.requestDetail.id}
							</div>
						</>
					)}
				</div>

				<div>
					<Button small square ghost onClick={onClose}>
						<IconCross />
					</Button>
				</div>
			</div>

			<div
				css={css`
					height: 100%;
					overflow: auto;
				`}
			>
				{!fetching && <ExportToCalendar data={data.requestDetail} />}
			</div>
		</div>
	);
};
